
const Button = ({onClick,color,title,textColor}) => {
  return (
      <button onClick= {onClick} className={`${color} ${textColor || "text-colorPrimary"} text-13 c-lg:text-14 c-xl:text-16 font-semibold font-sans w-[142px] h-[42px] rounded-full duration-500 nav-button`}>
        {title}
      </button>
  )
}

export default Button